module.exports = __webpack_public_path__ + "static/header_title_en-d7a58c337ca691a1ad15f326a1977a87.png";